<template>
    <div>
        <transition name="fade">
            <div class="search-backdrop" v-show="searchFocus" @click="searchFocus = false"></div>
        </transition>
        <div class="search-box"  itemscope="" itemtype="https://schema.org/WebSite">
            <meta itemprop="url" content="https://www.elektrobode.nl">
            <form itemprop="potentialAction" itemscope="" itemtype="https://schema.org/SearchAction" method="get" action="/search?query={query}" name="search-form">
                <meta itemprop="target" content="https://www.elektrobode.nl/search?query={query}">

                <div class="search-input-container position-relative">
                    <input name="query" type="text" itemprop="query-input" required="true" ref="query" :placeholder="placeholder" class="query animated-input" v-model="query" v-on:keyup="autoComplete" autocomplete="off" @focus="searchFocus = true" :class="{ active: notEmptyObject(results) && searchFocus }">
                    <span v-if="searching" class="searching-spinner fa fa-circle-o-notch fa-spin"></span>
                    <span v-if="query.length" class="search-input-remove" @click="removeQuery()"><i class="fa fa-times" aria-hidden="true"></i></span>
                </div>

                <transition name="slide">
                    <div class="search-autocomplete full-width position-absolute" v-show="notEmptyObject(results) && searchFocus">
                        <ul class="list-group">
                            <div class="search-type-results">
                                <div v-if="productClasses.length" class="search-type-box">
                                    <li class="list-group-item" v-for="productClass in productClasses">
                                        <a :href="'/search?product_class='+ productClass.Id" class="d-block full-width tiny-text small-text-md"><span class="search-type">Klasse</span>{{ productClass.Description }}</a>
                                    </li>
                                </div>

                                <div v-if="categories.length" class="search-type-box">
                                    <li class="list-group-item" v-for="category in categories">
                                        <a :href="categoryRoute.replace('CATEGORYID', category.Slug)" class="d-block full-width tiny-text small-text-md"><span class="search-type">Categorieën</span>{{ category.FrontendTitle }}<span class="d-block d-md-inline-block pl-md-2 micro-text light-text">{{category.Scope}}</span></a>
                                    </li>
                                </div>

                                <div v-if="brands.length" class="search-type-box">
                                    <li class="list-group-item" v-for="brand in brands">
                                        <a :href="brandRoute.replace('BRANDID', brand.Slug)" class="d-block full-width tiny-text small-text-md"><span class="search-type">Merken</span><span class="result">{{ brand.FrontendTitle }}</span></a>
                                    </li>
                                </div>

                                <div v-if="products.length" class="search-type-box">
                                    <li class="list-group-item" v-for="product in products">
                                        <a :href="productRoute.replace('PRODUCTID', product.Slug)" class="d-block full-width tiny-text small-text-md">
                                            <div class="row">
                                                <div class="col-2 col-sm-1 col-md-2">
                                                    <img :src="product.ImageUrl" class="img-fluid mr-2" width="50">
                                                </div>
                                                <div class="col-10 col-sm-11 col-md-10 mb-3">
                                                    <span>{{ product.Title }}</span>
                                                </div>
                                            </div>

                                        </a>
                                    </li>
                                </div>
                            </div>
                        </ul>
                    </div>
                </transition>
                <div class="search-autocomplete full-width position-absolute" v-if="noResults && searchFocus">
                    <div class="list-group-item" @click="submitForm()">
                        Zoeken naar "{{query}}"
                    </div>
                </div>
                <button class="submit" type="submit" :class="{ searchFocus: notEmptyObject(results) && searchFocus }"><i class="fa fa-search" aria-hidden="true"></i></button>
            </form>
        </div>
    </div>

</template>

<script>
    export default {

        props: [
            'slug',
            'placeholder',
            'productRoute',
            'categoryRoute',
            'brandRoute',
            'searchQuery',
            'currentRoute'
        ],

        data() {
            return {
                query: '',
                results: [],
                noResults: false,
                categories: [],
                brands: [],
                products: [],
                productClasses: [],
                timeout: 0,
                lastQuery: '',
                searching: false,
                minChars: 3, //The minimum required characters before an api search is initiated,
                searchFocus: false,
                submitted: false
            }
        },

        mounted() {
            this.searchRequest = this.makeSearchRequest();
            if (this.currentRoute === 'search.index') {
                this.query = this.searchQuery;
            }
        },

        methods: {
            autoComplete() {
                this.noResults = false;

                if(this.query.length === 0) {
                    this.resetQuery();
                }

                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }


                this.timeout = setTimeout(() => {
                    this.search(this.searchRequest);
                }, 300);

            },



            search(searchRequest) {
                if(this.query.length >= this.minChars && this.lastQuery !== this.query){
                    this.lastQuery = this.query;
                    this.results = [];
                    this.categories = [];
                    this.brands = [];
                    this.productClasses = [];
                    this.products = [];
                    this.searching = true;
                    this.noResults = false;

                    searchRequest();
                }
            },

            makeSearchRequest()
            {
                let call;
                let self = this;
                return function() {
                    if (call) {
                        call.cancel();
                    }
                    call = axios.CancelToken.source();

                    return axios.get('/api/search',{params: {query: self.query}, cancelToken: call.token}).then(response => {

                        self.searching = false;
                        if(response.data.total > 0) {
                            self.results = response.data;


                            if (typeof self.results.Categories !== 'undefined'){
                                self.categories = self.results.Categories;
                            }

                            if (typeof self.results.Brands !== 'undefined'){
                                self.brands = self.results.Brands;
                            }

                            if (typeof self.results.ProductClasses !== 'undefined') {
                                self.productClasses = self.results.ProductClasses;
                            }

                            if (typeof self.results.Products !== 'undefined') {
                                self.products = self.results.Products;
                            }

                            window.quicksearchquery = self.query;
                        } else {
                            self.noResults = true;
                            self.results = [];
                        }

                    }).catch(function(thrown) {
                        if (axios.isCancel(thrown)) {
                            console.log('First request canceled', thrown.message);
                        } else {
                            // handle error
                        }
                    });
                }
            },

            notEmptyObject(someObject){
                return Object.keys(someObject).length
            },

            submitForm() {
                document.getElementsByName('search-form')[0].submit();
            },

            removeQuery()
            {
                this.resetQuery();
                this.$refs.query.focus();
            },

            resetQuery()
            {
                this.query = '';
                this.lastQuery = '';
                this.results = [];
            }
        }
    }

    document.addEventListener('keydown', function(e){
        return handleForm(e);
    });

    function handleForm(e){
        let key = e.which || e.keyCode || 0;
        if (document.activeElement !== document.getElementsByName('query')[0]) {
            return; //Search input is not in focus
        }

        let listgroup = document.querySelectorAll('.list-group li');

        if (listgroup.length < 1){
            return;
        }

        let selected = false;

        for (let index=0; index<listgroup.length; ++index){
            if (listgroup[index].classList.contains('selected')){
                selected = index;
            }
        }
        if (selected === false){
            switch (key){
                case 38: //up
                    selected = 0;
                    break;
                case 40: //down
                    selected = listgroup.length -1;
                    break;
                case 13: //enter, so look if a search term matches 100%
                    for (let index=0; index<listgroup.length; ++index){
                        if (listgroup[index].querySelectorAll('.result').length > 0){
                            let searchResult = listgroup[index].querySelectorAll('.result')[0].innerHTML.toLowerCase();
                            let query = window.quicksearchquery.toLowerCase();
                            if (query === searchResult){
                                let link = listgroup[index].querySelectorAll('a');
                                if (link.length < 1){
                                    return; //Strange!
                                }
                                link[0].classList.add('selected');
                                link[0].click();
                                e.preventDefault();
                                return true;
                            }
                        }
                    }
                    document.getElementsByName('search-form')[0].submit();
                    //e.preventDefault();
                    return;
                    break;
            }
            listgroup[ selected ].classList.add('selected');
        }

        let selectedItem = listgroup[selected];
        switch (key) {
            case 38: // up
                selectedItem.classList.remove('selected');

                --selected;
                if (selected < 0){
                    selected = listgroup.length -1;
                }

                listgroup[ selected ].classList.add('selected');

                break;

            case 40: // down
                selectedItem.classList.remove('selected');

                ++selected;
                if (selected > (listgroup.length -1)){
                    selected = 0;
                }

                listgroup[ selected ].classList.add('selected');
                break;

            case 13: // enter
                let chosen = listgroup [ selected ];
                let link = chosen.querySelectorAll('a');
                if (link.length < 1){
                    return; //Strange!
                }
                link[0].click();
                break;

            default:
                return; // exit this handler for other keys
        }
        e.preventDefault();
    }
</script>
